<!-- Assigned Files Display -->
<div
  class="attachment-manager"
  [class.drag-over]="dragOver"
  (drop)="onFileDrop($event)"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave()"
>

  <!-- Header with action buttons -->
  <div class="manager-header" *ngIf="!readonly">
    <div class="header-actions">
      <button type="button" class="action-btn primary" (click)="openPicker()">
        <i class="pi pi-folder-open"></i>
        <span>Vybrat ze souborů</span>
      </button>

      <label class="action-btn upload">
        <i class="pi pi-cloud-upload"></i>
        <span>Nahrát nový</span>
        <input type="file" (change)="onFileSelect($event)" hidden>
      </label>
    </div>
  </div>

  <!-- Uploading indicator -->
  <div class="upload-progress" *ngIf="uploading">
    <div class="progress-content">
      <i class="pi pi-spin pi-spinner"></i>
      <span>Nahrávám soubor...</span>
    </div>
  </div>

  <!-- Assigned files grid -->
  <div class="assigned-files" *ngIf="assignments.length > 0">
    <div
      *ngFor="let assignment of assignments; trackBy: trackByAssignment"
      class="file-card"
      [class.is-image]="isImage(assignment.attachment!)"
    >
      <!-- Image thumbnail -->
      <div class="file-preview" *ngIf="assignment.attachment">
        <ng-container *ngIf="isImage(assignment.attachment)">
          <img [src]="assignment.attachment.thumbnailUrl || assignment.attachment.url" [alt]="assignment.attachment.fileName">
        </ng-container>
        <ng-container *ngIf="!isImage(assignment.attachment)">
          <i class="pi" [ngClass]="getFileIcon(assignment.attachment)"></i>
        </ng-container>
      </div>

      <!-- File info -->
      <div class="file-info" *ngIf="assignment.attachment">
        <span class="file-name" [title]="assignment.attachment.fileName">
          {{ assignment.attachment.fileName }}
        </span>
        <span class="file-meta">
          {{ formatSize(assignment.attachment.fileSize) }}
        </span>
      </div>

      <!-- Actions -->
      <div class="file-actions">
        <a
          [href]="assignment.attachment?.url"
          target="_blank"
          class="file-action-btn"
          pTooltip="Otevřít"
        >
          <i class="pi pi-external-link"></i>
        </a>
        <button
          *ngIf="!readonly"
          type="button"
          class="file-action-btn remove"
          (click)="unassignFile(assignment)"
          pTooltip="Odebrat"
        >
          <i class="pi pi-times"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- Empty state -->
  <div class="empty-state" *ngIf="assignments.length === 0 && !uploading">
    <div class="empty-icon">
      <i class="pi" [ngClass]="dragOver ? 'pi-cloud-upload' : 'pi-folder-open'"></i>
    </div>
    <span class="empty-text">{{ dragOver ? 'Pusťte soubor pro nahrání' : 'Žádné přiřazené soubory' }}</span>
    <span class="empty-hint" *ngIf="!readonly && !dragOver">Přetáhněte soubor sem nebo klikněte pro přidání</span>
  </div>

</div>

<!-- File Picker Modal -->
<p-dialog
  [(visible)]="showPicker"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{width: '720px', maxWidth: '95vw'}"
  styleClass="attachment-picker-dialog"
  [showHeader]="false"
>
  <div class="picker-container">

    <!-- Picker Header -->
    <div class="picker-header">
      <div class="header-title">
        <i class="pi pi-folder-open"></i>
        <span>Vybrat soubor</span>
      </div>
      <button type="button" class="close-btn" (click)="closePicker()">
        <i class="pi pi-times"></i>
      </button>
    </div>

    <!-- Search -->
    <div class="picker-search">
      <i class="pi pi-search search-icon"></i>
      <input
        type="text"
        placeholder="Hledat v souborech..."
        [value]="searchTerm"
        (input)="onSearchChange($event)"
        class="search-input"
      >
    </div>

    <!-- Drop zone -->
    <div
      class="drop-zone"
      [class.active]="dragOver"
      (drop)="onFileDrop($event)"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave()"
    >
      <div class="drop-content">
        <i class="pi pi-cloud-upload"></i>
        <span>Přetáhněte soubor sem nebo</span>
        <label class="browse-link">
          procházejte
          <input type="file" (change)="onFileSelect($event)" hidden>
        </label>
      </div>
    </div>

    <!-- Files list -->
    <div class="picker-files">
      <div class="files-header">
        <span class="header-label">Dostupné soubory</span>
        <span class="files-count">{{ availableFiles.length }}</span>
      </div>

      <!-- Loading -->
      <div class="loading-state" *ngIf="loadingFiles">
        <i class="pi pi-spin pi-spinner"></i>
        <span>Načítám soubory...</span>
      </div>

      <!-- Files grid -->
      <div class="files-grid" *ngIf="!loadingFiles && availableFiles.length > 0">
        <div
          *ngFor="let file of availableFiles; trackBy: trackByFile"
          class="file-item"
          (click)="assignFile(file)"
        >
          <div class="file-thumb">
            <ng-container *ngIf="isImage(file)">
              <img [src]="file.thumbnailUrl || file.url" [alt]="file.fileName">
            </ng-container>
            <ng-container *ngIf="!isImage(file)">
              <i class="pi" [ngClass]="getFileIcon(file)"></i>
            </ng-container>
          </div>
          <div class="file-details">
            <span class="file-name">{{ file.fileName }}</span>
            <span class="file-size">{{ formatSize(file.fileSize) }}</span>
          </div>
          <div class="file-select-indicator">
            <i class="pi pi-plus-circle"></i>
          </div>
        </div>
      </div>

      <!-- Empty state -->
      <div class="no-files" *ngIf="!loadingFiles && availableFiles.length === 0">
        <i class="pi pi-inbox"></i>
        <span *ngIf="searchTerm">Žádné soubory nenalezeny</span>
        <span *ngIf="!searchTerm">Všechny soubory jsou již přiřazeny</span>
      </div>
    </div>

  </div>
</p-dialog>
